<template>
  <v-banner
      v-model="showBanner"
      :sticky="showBanner"
      app
      :color="color"
      rounded
      elevation="19"
      :max-width="maxWidth"
      class="mx-auto white--text"
      single-line
      :style="{ marginLeft: maxWidth === '85%' ? '15% !important' : '' }"
  >
    <div v-if="isProfileBanner">{{user.username}} please complete your profile</div>
    <div v-if="isWebinarBanner" class="d-flex flex-wrap flex-row justify-space-around align-center heading">
      <div class="mr-3">JOIN OUR FREE WEBINAR - SEPTEMBER 10th 2022 - {{ days }} days, {{ hours }} hours, {{ minutes }} minutes</div>
      <a v-if="showJoinNowButton" href="https://meet.google.com/bpw-onhe-ypm" target="_blank">
        <v-btn elevation="0" depressed rounded text style="color: white">
          Join Now
        </v-btn>
      </a>
      <v-btn v-else elevation="0" depressed to="/webinar-registration/" style="color: #0033AA">
        Register Now
      </v-btn>
    </div>
    <template  v-slot:actions="{ dismiss }">
      <v-btn class="hidden-sm-and-down" v-if="isProfileBanner" elevation="0" depressed rounded text to="/profile/" style="color: white">
        Edit Profile
      </v-btn>
      <v-btn class="hidden-sm-and-down" elevation="0" depressed rounded text @click="dismiss" style="color: white"> Dismiss</v-btn>
    </template>
  </v-banner>
</template>

<script>
export default {
  name: "AppBanner",
  data: function () {
    return {
      webinarDate: "9/10/2022, 8:00:00 AM",
      days: "",
      hours: "",
      minutes: "",
      timer: ""
    }
  },
  props: {
    model: {
      required: true,
      type: Boolean,
      default: false
    },
    isProfileBanner: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({ username: "" })
    },
    isWebinarBanner: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "orange"
    },
    maxWidth: {
      type: String,
      default: "90%"
    }
  },
  computed: {
    showBanner: {
      get: function() {
        return this.model
      },
      set: function (value) {
        return value
      }
    },
    showJoinNowButton() {
      return (new Date('2022-09-10').toDateString() ===  new Date().toLocaleDateString())
    }
  },
  mounted() {
    let end = new Date('2022-09-10').getTime();
    this.timerCount(end);
    this.timer = setInterval(() => {
      this.timerCount(end);
    }, 1000);
  },
  methods: {
    timerCount(end){
      this.startTime = new Date().getTime();
      this.distance =  end - this.startTime;
      this.calculateTime(this.distance);
    },
    calculateTime(dist){
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>

<style scoped>

</style>
